/* eslint-disable */
export class FieldAutomationIds {
	public static readonly clientNumberCellLabel: string = 'clientNumberCellLabel';
	public static readonly institutionNameLabel: string = 'institutionNameLabel';
	public static readonly institutionCityLabel: string = ' institutionCityLabel';
	public static readonly salutationDropdown: string = 'salutationDropdown';
	public static readonly employeeFirstName: string = 'employeeFirstName';
	public static readonly employeeMiddleName: string = 'employeeMiddleName';
	public static readonly employeeLastName: string = 'employeeLastName';
	public static readonly suffixDropdown: string = 'suffixDropdown';
	public static readonly preferredName: string = 'preferredName';
	public static readonly genderTypeRadio: string = 'genderRadio';
	public static readonly genderIdentityOptions: string = 'genderIdentityOptions';
	public static readonly genderIdentityOther: string = 'genderIdentityOther';

	public static readonly dateOfBirth: string = 'dateOfBirth';
	public static readonly taxId: string = 'taxId';
	public static readonly countryDropdown: string = 'countryDropdown';
	public static readonly addressLine1: string = 'addressLine1';
	public static readonly city: string = 'city';
	public static readonly stateDropdown: string = 'stateDropdown';
	public static readonly postalCode: string = 'postalCode';
	public static readonly businessEmail: string = 'businessEmail';
	public static readonly personalEmail: string = 'personalEmail';
	public static readonly employeeTypeRadio: string = 'employeeTypeRadio';
	public static readonly formCancelButton: string = 'formCancelButton';
	public static readonly formSubmitButton: string = 'formSubmitButton';


	public static readonly clergyIsTECQuestionRadio: string = 'clergyIsTECQuestionRadio';
	public static readonly dateOfLicensing: string = 'dateOfLicensing';
	public static readonly dioLicensedInDropdown: string = 'dioLicensedInDropdown';
	public static readonly licensedByDropdown: string = 'licensedByDropdown';
	public static readonly anotherDenomination: string = 'anotherDenomination';



	public static readonly hiringDate: string = 'hiringDate';
	public static readonly positionTitleDropdown: string = 'positionTitleDropdown';
	public static readonly positionEffectiveDate: string = 'positionEffectiveDate';
	public static readonly positionEndDate: string = 'positionEndDate';
	public static readonly publishedTitle: string = 'publishedTitle';
	public static readonly hoursExpectedToWork: string = 'hoursExpectedToWork';
	public static readonly scheduleHoursEffectiveDate: string = 'scheduleHoursEffectiveDate';
	public static readonly compensationTypeRadio: string = 'compensationTypeRadio';
	public static readonly effectiveDateOfCompensation: string = 'effectiveDateOfCompensation';
	public static readonly oneTimeSalaryAmount: string = 'oneTimeSalaryAmount';
	public static readonly baseSalaryAmount: string = 'baseSalaryAmount';
	public static readonly employerContibutions: string = 'employerContibutions';
	public static readonly cashHousingAllowance: string = 'cashHousingAllowance';
	public static readonly employerProviderHousingRadio: string = 'employerProviderHousingRadio';

}